import axios from 'axios'
import api from '../api/commonApi'
import Vue from 'vue'
// 配置请求的根路径
//axios.defaults.baseURL = 'http://127.0.0.1:8888/api/private/v1/'
axios.defaults.baseURL = 'http://sys.cssgkj.com:8089/'
//axios.defaults.baseURL = 'http://127.0.0.1:8080/'


// 是否正在刷新的标志
window.isRefreshing = false;
// 存储请求的数组
let cacheRequestArr = [];

// 将所有的请求都push到数组中,其实数组是[function(token){}, function(token){},...]
function cacheRequestArrHandle(cb) {
  cacheRequestArr.push(cb);
}
// 数组中的请求得到新的token之后自执行，用新的token去重新发起请求
function afreshRequest(token) {
  cacheRequestArr.map(cb => cb(token));
  cacheRequestArr = [];
}
// 判断token是否即将过期
function isTokenExpired() {
  let curTime = new Date().getTime();
  // 没有过期时间说明没有token
  let expires = window.localStorage.getItem('token-expires') || 0
  let expiresTime = Number(expires) - curTime;
  // 天
  if (expiresTime <= 0) {
    return true
  }
  return false;
}

const excludeUrl = [
  "/user/login",
  "/user/getToken",
]

// 请求拦截器--
axios.interceptors.request.use(
  config => {
    config.headers['lang'] = window.localStorage.getItem('language')

    if (window.localStorage.getItem('token') && !isTokenExpired()) {
      config.headers['Authorization'] = window.localStorage.getItem('token')
      return config;
    } else if (isTokenExpired() && !excludeUrl.includes(config.url)) {
      // 所有的请求来了，先判断是否正在刷新token，
      // 如果不是，将刷新token标志置为true并请求刷新token.
      // 如果是，则先将请求缓存到数组中
      // 等到刷新完token后再次重新请求之前缓存的请求接口即可
      if (!window.isRefreshing) {
        // 标志改为true，表示正在刷新
        window.isRefreshing = true;
        api.anonymousLogin({}).then(res => {
          if (res.code == 200) {
            window.localStorage.setItem('token', res.data.token)
            window.localStorage.setItem('token-expires', new Date().getTime() + 1000 * 60 * 60 * 24 * 5)

            // 将刷新的token替代老的token
            config.headers['Authorization'] = window.localStorage.getItem('token');
            // 刷新token完成后重新请求之前的请求
            afreshRequest(window.localStorage.getItem('token'))
          }
        }).catch(err => {
          console.log('getToken err =>' + err);
        }).finally(() => {
          window.isRefreshing = false;
        })
        let retry = new Promise((resolve) => {
          cacheRequestArrHandle((token) => {
            config.headers['Authorization'] = token; // token为刷新完成后传入的token
            config.headers['lang'] = window.localStorage.getItem('language')
            // 将请求挂起
            resolve(config)
          })
        })
        return retry;
      } else {
        let retry = new Promise((resolve) => {
          cacheRequestArrHandle((token) => {
            config.headers['Authorization'] = token; // token为刷新完成后传入的token
            config.headers['lang'] = window.localStorage.getItem('language')
            // 将请求挂起
            resolve(config)
          })
        })
        return retry;
      }
    } else {
      return config
    }
  },
  error => {
    // 请求错误处理
    Promise.reject(error)
  }

)

axios.interceptors.response.use((res => {
  if (res && res.data) {
    if (res.data.code == 200) {
      return res.data
    } else if (res.data.code == 604) {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('token-expires')
      // 无token
      // api.anonymousLogin({}).then(res => {
      //   window.localStorage.setItem('token', res.data.token)
      // })
      //this.$bus.$emit("refresh", "refresh") 
    }
  }


}))
Vue.prototype.$http = axios